import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../../Auth/tokenKeys";
import styles from "./Callback.module.css";

const parseHashParams = (): Record<string, string> => {
  const raw = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  if (!raw) return {};
  return Object.fromEntries(new URLSearchParams(raw));
};

const Callback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = parseHashParams();
    const access = params.access?.trim();
    const refresh = params.refresh?.trim();
    if (access && refresh) {
      sessionStorage.setItem(ACCESS_TOKEN_KEY, access);
      sessionStorage.setItem(REFRESH_TOKEN_KEY, refresh);
      navigate("/agendar", { replace: true });
    } else {
      navigate("/login?oauth_error=missing_tokens", { replace: true });
    }
  }, [navigate]);

  return (
    <div className={styles.container}>
      <h1>Callback Page</h1>
    </div>
  );
};

export default Callback;
